export const localValidate = (formState) => {
  let errors = {};

  return errors;
};

const ClubTimesWithParamsValidation = async (formState) => {
  let errors = localValidate(formState);

  return errors ? errors : {};
};

export default ClubTimesWithParamsValidation;